export type BridgeClientKind =
  | 'web-dev'
  | 'web-prod'
  | 'electron-mac'
  | 'electron-win'
  | 'capacitor'
  | 'unknown';

/** Bridge /v1/context に載せる接続元情報（スクリプトが dev 判定に使う） */
export interface BridgeClientInfo {
  kind: BridgeClientKind;
  origin: string;
  /** POST /v1/sheets 等の有無 */
  apiVersion: number;
  capabilities: readonly string[];
}

const BRIDGE_API_VERSION = 3;
const BRIDGE_CAPABILITIES = [
  'read_sheet',
  'write_sheet',
  'delete_sheet',
  'activate_sheet',
  'create_sheet',
  'tidy_sheet',
  'add_layer',
  'delete_layer',
  'create_snapshot',
  'undo_sheet',
  'redo_sheet',
] as const;

function detectElectronPlatform():
  | 'electron-mac'
  | 'electron-win'
  | 'unknown' {
  if (typeof window === 'undefined') return 'unknown';
  const electron = (window as { electron?: { isElectron?: boolean; platform?: string } })
    .electron;
  if (!electron?.isElectron) return 'unknown';
  const platform = (electron.platform ?? '').toLowerCase();
  if (platform.includes('win')) return 'electron-win';
  if (platform.includes('mac') || platform.includes('darwin')) return 'electron-mac';
  return 'unknown';
}

/** 現在の POUCHES クライアント種別を返す */
export function getBridgeClientInfo(): BridgeClientInfo {
  if (typeof window === 'undefined') {
    return {
      kind: 'unknown',
      origin: '',
      apiVersion: BRIDGE_API_VERSION,
      capabilities: BRIDGE_CAPABILITIES,
    };
  }

  const origin = window.location.origin;
  const isDev = process.env.NODE_ENV === 'development';
  const electronKind = detectElectronPlatform();
  const cap = (window as {
    Capacitor?: { isNativePlatform?: () => boolean };
  }).Capacitor;
  const isCapacitorNative = cap?.isNativePlatform?.() === true;

  let kind: BridgeClientKind;
  if (electronKind !== 'unknown') {
    kind = electronKind;
  } else if (isCapacitorNative) {
    kind = 'capacitor';
  } else if (isDev) {
    kind = 'web-dev';
  } else {
    kind = 'web-prod';
  }

  return {
    kind,
    origin,
    apiVersion: BRIDGE_API_VERSION,
    capabilities: BRIDGE_CAPABILITIES,
  };
}
